import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import Highlighter from 'react-highlight-words';
import { LinkOutlined } from '@ant-design/icons';

const Container = styled.div`
  display: flex;
  align-items: stretch;
  position: relative;
  padding-right: 20px;
  > img {
    flex: 0 0 60px;
    width: 60px;
    height: 60px;
    margin-right: 8px;
  }
  > div {
    flex: 1 0 0;
  }
  > a {
    display: none;
  }
  &:hover {
    > a {
      display: block;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  mark {
    color: var(--fett-scenario-accent-text);
    background: transparent;
  }
`;

const Name = styled.div`
  > span {
    line-height: 20px;
    color: var(--fett-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

const ID = styled.div`
  line-height: 12px;
  font-size: 12px;
  color: var(--fett-text-tertiary);
`;

const Link = styled.a`
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: var(--fett-chat-bubble-agent);
  color: var(--fett-scenario-accent-text);
  border-radius: 2px;
  cursor: pointer;
`;

export interface ProductProps extends HTMLAttributes<HTMLDivElement> {
  keywords?: string;
  product: Conversation.Product;
}

function Product(props: ProductProps) {
  const { keywords = '', product, ...otherProps } = props;

  const {
    imageUrl: [imageUrl],
    itemName,
    externalItemId,
    itemUrl,
  } = product;

  return (
    <Container {...otherProps}>
      <img src={imageUrl} alt="product" />
      <Content>
        <Name title={itemName}>
          <Highlighter autoEscape searchWords={[keywords]} textToHighlight={itemName} />
        </Name>
        <ID>
          ID:
          <Highlighter autoEscape searchWords={[keywords]} textToHighlight={externalItemId} />
        </ID>
      </Content>
      <Link href={itemUrl} target="__blank">
        <LinkOutlined />
      </Link>
    </Container>
  );
}

export default Product;
